import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';

import { OpenContentDetailDialog } from '../../../app/actions/AppActionTypes';
import { requestFailed } from '../../../app/actions/RequestFailedAction';
import { Messages } from '../../../codegen/Localize';
import { OpenContentDetailDialogAction } from '../../actions/OpenContentDetailDialogActions';
import { ContentDetailsDialog } from '../../components/content/contentDetailDialog/ContentDetailsDialog';

// Open Detail Dialog
export function* handleOpenContentDetailDialog(action: OpenContentDetailDialogAction) {
  try {
    yield call(ContentDetailsDialog.open, action.content, action.availableActions, action.location);
  } catch(e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function* rootContentDetailDialogSaga(): SagaIterator {
  yield takeLatest(OpenContentDetailDialog, handleOpenContentDetailDialog);
}
